import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from "typeorm";
import { SectionWiseModel } from "./section-wise-model.entity";
import { Chapter } from "../../entities/chapter";

@Entity("chapter_wise_model")
export class ChapterWiseModel {
    @PrimaryGeneratedColumn({ type: "int", name: "id" })
    id: number;

    // @Column("varchar", { name: "chapter" })
    // chapter: number;
    @ManyToOne(() => Chapter, (chapterModel) => chapterModel.chapter)
    @JoinColumn({ name: 'chapter' })
    chapter: Chapter;

    @Column("int", { name: "no_of_qns" })
    noOfQns: number;

    @ManyToOne(() => SectionWiseModel, (qnpModel) => qnpModel.chapterWiseModel)
    @JoinColumn({ name: 'section_wise_model' })
    sectionWiseModel: SectionWiseModel;
}
